import UcInvoiceLines from './UcInvoiceLines.yaml?component';
import UploadInvoiceLines from './UploadInvoiceLines.yaml?component';

export { UcInvoiceLines, UploadInvoiceLines };
